<template>
  <vue-apex-charts :height="height" :type="type" :options="chartOptions"
    :series="series" :key="componentKey">
  </vue-apex-charts>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    graphColors: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '238'
    },
    labelList: {
      type: Array,
      default: () => []
    },
    series: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartOptions: {
        plotOptions: {
          radialBar: {
            offsetY: 0,
            offsetX: 80,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent',
              image: undefined
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                show: false
              }
            }
          }
        },
        colors: this.graphColors,
        labels: this.labelList,
        legend: {
          show: true,
          floating: true,
          fontSize: '13px',
          position: 'left',
          offsetX: 5,
          offsetY: 10,
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 0
          },
          itemMargin: {
            vertical: 3
          }
        }
      },
      componentKey: 0
    }
  },
  watch: {
    labelList: {
      handler() {
        this.$set(this.chartOptions, 'labels', this.labelList)
        this.componentKey += 1
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
